import { render, staticRenderFns } from "./Sixth.vue?vue&type=template&id=3f1b91a0&scoped=true"
import script from "./Sixth.vue?vue&type=script&lang=js"
export * from "./Sixth.vue?vue&type=script&lang=js"
import style0 from "./Sixth.vue?vue&type=style&index=0&id=3f1b91a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b91a0",
  null
  
)

export default component.exports